// import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import { workstationFields } from "./workstationFields";
// import { getNextWorkstationId , searchLocation} from "../../services/workstation/workstation.service";

// export default function CreateWorkstation({
//     initialValues,
//     onSubmit,
//     onCancel,
//     viewOnly,
//     isEdit
// }) {

//     const { userDetail } = useSelector((state) => state.login);

//     console.log("............................",userDetail)

//     const [formData, setFormData] = useState({
//         workstationId: "",
//         workstationType: "",
//         workstationLocation: "",
//         cameraIps: "",
//         printerIps: "",
//         marketplaceOrders: "",
//         excludedCommodity: "",
//         createdBy: "",
//         createdDate: "",
//         updatedBy: "",
//         updatedDate: ""
//     });
//     const [locationList, setLocationList] = useState([]);
//     const [showDropdown, setShowDropdown] = useState(false);

//     const handleLocationSearch = async (value) => {

//         handleChange("workstationLocation", value);

//         if (!value) {
//             setLocationList([]);
//             return;
//         }

//         try {
//             const data = await searchLocation(value);
//             setLocationList(data);
//             setShowDropdown(true);
//         } catch (err) {
//             console.error(err);
//         }
//     };


//     const selectLocation = (loc) => {
//         setFormData(prev => ({
//             ...prev,
//             workstationLocation: loc.locationName
//         }));

//         setShowDropdown(false);
//     };

//     /* ================= LOAD EDIT / VIEW ================= */
//     useEffect(() => {
//         if ((viewOnly || isEdit) && initialValues) {
//             setFormData({
//                 ...initialValues,
//                 cameraIps: initialValues.cameraIps?.join(", ") || "",
//                 printerIps: initialValues.printerIps?.join(", ") || "",
//                 marketplaceOrders: initialValues.marketplaceOrders?.join(", ") || ""
//             });
//         }
//     }, [initialValues, viewOnly, isEdit]);

//     /* ================= AUTO ID ================= */
//     useEffect(() => {
//         if (!viewOnly && !isEdit) {
//             fetchId();
//         }
//     }, []);

//     const fetchId = async () => {
//         const id = await getNextWorkstationId();
//         setFormData(prev => ({ ...prev, workstationId: id }));
//     };

//     /* ================= AUTO CREATED BY ================= */
//     useEffect(() => {
//         if (!viewOnly && !isEdit && userDetail) {
//             setFormData(prev => ({
//                 ...prev,
//                 createdBy: `${userDetail.email}`,
//                 createdDate: new Date().toISOString().split("T")[0]
//             }));
//         }
//     }, [userDetail]);

//     const handleChange = (name, value) => {
//         setFormData(prev => ({
//             ...prev,
//             [name]: value
//         }));
//     };

//     /* ================= SUBMIT ================= */
//     const submit = (e) => {
//         e.preventDefault();

//         const {
//             _id,
//             createdAt,
//             updatedAt,
//             ...rest
//         } = formData;

//         const payload = {
//             workstationId: rest.workstationId,
//             workstationType: rest.workstationType,
//             workstationLocation: rest.workstationLocation,

//             cameraIps: rest.cameraIps
//                 ?.split(",")
//                 .map(i => i.trim())
//                 .filter(Boolean),

//             printerIps: rest.printerIps
//                 ?.split(",")
//                 .map(i => i.trim())
//                 .filter(Boolean),

//             marketplaceOrders: rest.marketplaceOrders
//                 ?.split(",")
//                 .map(i => i.trim())
//                 .filter(Boolean),

//             excludedCommodity: rest.excludedCommodity,
//             activate: rest.activate,

//             // 🔥 CREATE TIME FIELDS
//             createdBy: !isEdit
//                 ? `${userDetail.firstName} ${userDetail.lastName}`
//                 : rest.createdBy,

//             createdDate: !isEdit
//                 ? new Date().toISOString().split("T")[0]
//                 : rest.createdDate,

//             // 🔥 UPDATE TIME FIELDS
//             updatedBy: isEdit
//                 ? `${userDetail.firstName} ${userDetail.lastName}`
//                 : "",

//             updatedDate: isEdit
//                 ? new Date().toISOString().split("T")[0]
//                 : ""
//         };

//         onSubmit(payload, initialValues?._id);
//     };

//     return (
//         <form onSubmit={submit}>
//             <div className="d-flex flex-wrap gap-3">
//                 {workstationFields.map(field => (
//                     <div key={field.name} style={{ flex: "0 0 23%" }}>
//                         <label className="form-label">
//                             {field.label}
//                             {field.required && (
//                                 <span className="text-danger"> *</span>
//                             )}
//                         </label>

//                         {/* SELECT FIELD */}
//                         {field.type === "select" ? (
//                             <select
//                                 className="form-select"
//                                 value={formData[field.name] || ""}
//                                 disabled={viewOnly}
//                                 onChange={(e) =>
//                                     handleChange(field.name, e.target.value)
//                                 }
//                             >
//                                 <option value="">Select</option>
//                                 {field.option.map(opt => (
//                                     <option key={opt} value={opt}>
//                                         {opt}
//                                     </option>
//                                 ))}
//                             </select>
//                         ) : field.name === "workstationLocation" ? (

//                             /* 🔥 LOCATION SEARCH INPUT */
//                             <div style={{ position: "relative" }}>

//                                 <input
//                                     type="text"
//                                     className="form-control"
//                                     value={formData.workstationLocation || ""}
//                                     readOnly={viewOnly}
//                                     onChange={(e) =>
//                                         handleLocationSearch(e.target.value)
//                                     }
//                                 />

//                                 {showDropdown && locationList.length > 0 && (
//                                     <div
//                                         style={{
//                                             position: "absolute",
//                                             top: "40px",
//                                             background: "#fff",
//                                             border: "1px solid #ddd",
//                                             width: "100%",
//                                             zIndex: 10,
//                                             maxHeight: "200px",
//                                             overflowY: "auto"
//                                         }}
//                                     >
//                                         {locationList.map(loc => (
//                                             <div
//                                                 key={loc._id}
//                                                 style={{
//                                                     padding: "8px",
//                                                     cursor: "pointer"
//                                                 }}
//                                                 onClick={() => selectLocation(loc)}
//                                             >
//                                                 {loc.locationName}
//                                             </div>
//                                         ))}
//                                     </div>
//                                 )}
//                             </div>

//                         ) : (

//                             /* NORMAL INPUT */
//                             <input
//                                 type="text"
//                                 className="form-control"
//                                 value={formData[field.name] || ""}
//                                 readOnly={viewOnly || field.readonly}
//                                 onChange={(e) =>
//                                     handleChange(field.name, e.target.value)
//                                 }
//                             />

//                         )}
//                     </div>
//                 ))}
//             </div>

//             <div className="d-flex justify-content-center gap-2 mt-3">
//                 <button
//                     type="button"
//                     className="btn btn-secondary"
//                     onClick={onCancel}
//                 >
//                     Back
//                 </button>

//                 {!viewOnly && (
//                     <button type="submit" className="btn btn-primary">
//                         {isEdit ? "Update" : "Save"}
//                     </button>
//                 )}
//             </div>
//         </form>
//     );
// }





import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { workstationFields } from "./workstationFields";
import {
    getNextWorkstationId,
    searchLocation
} from "../../services/workstation/workstation.service";

export default function CreateWorkstation({
    initialValues,
    onSubmit,
    onCancel,
    viewOnly,
    isEdit
}) {

    const { userDetail } = useSelector((state) => state.login);

    const [formData, setFormData] = useState({
        workstationId: "",
        workstationType: "",
        workstationLocation: "",
        cameraIps: "",
        printerIps: "",
        marketplaceOrders: "",
        excludedCommodity: "",
        createdBy: "",
        createdDate: "",
        updatedBy: "",
        updatedDate: ""
    });

    const [locationList, setLocationList] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [locationError, setLocationError] = useState("");
    const [searchValue, setSearchValue] = useState("");

    /* ================= LOCATION INPUT ================= */

    const handleLocationSearch = (value) => {

        handleChange("workstationLocation", value);
        setSearchValue(value);
        setLocationError("");

    };

    /* ================= DEBOUNCED SEARCH ================= */

    useEffect(() => {

        const delayDebounce = setTimeout(async () => {

            if (!searchValue) {
                setLocationList([]);
                setShowDropdown(false);
                return;
            }

            try {

                const data = await searchLocation(searchValue);

                if (data.length === 0) {

                    setLocationError("Location not found");
                    setLocationList([]);

                } else {

                    setLocationList(data);
                }

                setShowDropdown(true);

            } catch (err) {

                console.error(err);

            }

        }, 600); // debounce delay

        return () => clearTimeout(delayDebounce);

    }, [searchValue]);

    const selectLocation = (loc) => {

        setFormData(prev => ({
            ...prev,
            workstationLocation: loc.locationName
        }));

        setShowDropdown(false);
        setLocationError("");

    };

    /* ================= LOAD EDIT ================= */

    useEffect(() => {

        if ((viewOnly || isEdit) && initialValues) {

            setFormData({
                ...initialValues,
                cameraIps: initialValues.cameraIps?.join(", ") || "",
                printerIps: initialValues.printerIps?.join(", ") || "",
                marketplaceOrders: initialValues.marketplaceOrders?.join(", ") || ""
            });

        }

    }, [initialValues, viewOnly, isEdit]);

    /* ================= AUTO ID ================= */

    useEffect(() => {

        if (!viewOnly && !isEdit) {
            fetchId();
        }

    }, []);

    const fetchId = async () => {

        const id = await getNextWorkstationId();

        setFormData(prev => ({
            ...prev,
            workstationId: id
        }));

    };

    /* ================= CREATED BY ================= */

    useEffect(() => {

        if (!viewOnly && !isEdit && userDetail) {

            setFormData(prev => ({
                ...prev,
                createdBy: userDetail.email,
                createdDate: new Date().toISOString().split("T")[0]
            }));

        }

    }, [userDetail]);

    const handleChange = (name, value) => {

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

    };

    /* ================= SUBMIT ================= */

    const submit = (e) => {

        e.preventDefault();

        const { _id, createdAt, updatedAt, ...rest } = formData;

        const payload = {

            workstationId: rest.workstationId,
            workstationType: rest.workstationType,
            workstationLocation: rest.workstationLocation,

            cameraIps: rest.cameraIps
                ?.split(",")
                .map(i => i.trim())
                .filter(Boolean),

            printerIps: rest.printerIps
                ?.split(",")
                .map(i => i.trim())
                .filter(Boolean),

            marketplaceOrders: rest.marketplaceOrders
                ?.split(",")
                .map(i => i.trim())
                .filter(Boolean),

            excludedCommodity: rest.excludedCommodity,
            activate: rest.activate,

            createdBy: !isEdit
                ? `${userDetail.firstName || ""} ${userDetail.lastName || ""}`
                : rest.createdBy,

            createdDate: !isEdit
                ? new Date().toISOString().split("T")[0]
                : rest.createdDate,

            updatedBy: isEdit
                ? `${userDetail.firstName || ""} ${userDetail.lastName || ""}`
                : "",

            updatedDate: isEdit
                ? new Date().toISOString().split("T")[0]
                : ""

        };

        onSubmit(payload, initialValues?._id);

    };

    return (

        <form onSubmit={submit}>

            <div className="d-flex flex-wrap gap-3">

                {workstationFields.map(field => (

                    <div key={field.name} style={{ flex: "0 0 23%" }}>

                        <label className="form-label">
                            {field.label}
                            {field.required && (
                                <span className="text-danger"> *</span>
                            )}
                        </label>

                        {field.name === "workstationLocation" ? (

                            <div style={{ position: "relative" }}>

                                {locationError && (
                                    <div style={{ color: "red", fontSize: "12px", marginBottom: "4px" }}>
                                        {locationError}
                                    </div>
                                )}

                                <input
                                    type="text"
                                    className="form-control"
                                    value={formData.workstationLocation || ""}
                                    readOnly={viewOnly}
                                    onChange={(e) =>
                                        handleLocationSearch(e.target.value)
                                    }
                                    placeholder="Search location"
                                />

                                {showDropdown && locationList.length > 0 && (

                                    <div
                                        style={{
                                            position: "absolute",
                                            top: "40px",
                                            background: "#fff",
                                            border: "1px solid #ddd",
                                            width: "100%",
                                            zIndex: 10,
                                            maxHeight: "200px",
                                            overflowY: "auto"
                                        }}
                                    >

                                        {locationList.map(loc => (

                                            <div
                                                key={loc._id}
                                                style={{
                                                    padding: "8px",
                                                    cursor: "pointer"
                                                }}
                                                onClick={() => selectLocation(loc)}
                                            >
                                                {loc.locationName}
                                            </div>

                                        ))}

                                    </div>

                                )}

                            </div>

                        ) : field.type === "select" ? (

                            <select
                                className="form-select"
                                value={formData[field.name] || ""}
                                disabled={viewOnly}
                                onChange={(e) =>
                                    handleChange(field.name, e.target.value)
                                }
                            >

                                <option value="">Select</option>

                                {field.option.map(opt => (
                                    <option key={opt} value={opt}>
                                        {opt}
                                    </option>
                                ))}

                            </select>

                        ) : (

                            <input
                                type="text"
                                className="form-control"
                                value={formData[field.name] || ""}
                                readOnly={viewOnly || field.readonly}
                                onChange={(e) =>
                                    handleChange(field.name, e.target.value)
                                }
                            />

                        )}

                    </div>

                ))}

            </div>

            <div className="d-flex justify-content-center gap-2 mt-3">

                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={onCancel}
                >
                    Back
                </button>

                {!viewOnly && (
                    <button type="submit" className="btn btn-primary">
                        {isEdit ? "Update" : "Save"}
                    </button>
                )}

            </div>

        </form>
    );
}

